<template lang="pug">
footer.Footer
  .Footer__inner
    section.Footer__logo
      h2: a(href="/") DESIGN BASE
      p ホームページ制作に役立つ情報を発信するDESIGN BASE。無料相談も受け付けておりますので、お気軽にご相談ください。
    ul.Footer__menu
      li 種類
      ul
        li(v-for="category in taxonomies.categories")
          router-link(
            :to="{ name: 'category', params: { id: category.id, taxonomy: category.taxonomy } }",
            @click="navigate()"
          ) {{ category.name }} ({{ category.indices_count }})
      li 業種
      ul
        li(v-for="type in taxonomies.types")
          router-link(
            :to="{ name: 'category', params: { id: type.id, taxonomy: type.taxonomy } }",
            @click="navigate()"
          ) {{ type.name }} ({{ type.indices_count }})
      li 施設
      ul
        li(v-for="place in taxonomies.places")
          router-link(
            :to="{ name: 'category', params: { id: place.id, taxonomy: place.taxonomy } }",
            @click="navigate()"
          ) {{ place.name }} ({{ place.indices_count }})
    .Footer__copyright Copyright © 2019 ORIENT SAILING PARTNERS LLC. ALL RIGHTS RESERVED.
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["query", "taxonomies", "page"]),
  },
  methods: {
    ...mapActions(["fetchIndices"]),
    ...mapMutations([
      "unsetIndices",
      "unsetTaxonomies",
      "updateTaxonomies",
      "stopScroll",
      "toggleLoading",
    ]),
    navigate() {
      console.log("navigate");
      this.unsetIndices();
      this.unsetTaxonomies();
      const id = this.$route.params.id;
      const taxonomy = this.$route.params.taxonomy;

      if (taxonomy) {
        this.$store.commit(
          `set${taxonomy[0].toUpperCase() + taxonomy.slice(1)}`,
          id
        );
      }

      this.toggleLoading();
      this.stopScroll();
      window.setTimeout(() => {
        this.fetchIndices({ page: this.page, query: this.query });
        this.toggleLoading();
      }, 1000);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";

.Footer {
  width: 100%;
  font-size: 24px;
  font-weight: bold;
  line-height: 50px;
  background: var(--footerBackground);
  color: #fff;
  .Footer__inner {
    width: 100%;
    margin: 0 auto;
    padding: $space-l 24px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    @media only screen and( max-width: $tablet) {
      width: 100%;
      padding: $space-l $space-m 0;
    }
    a {
      color: #fff;
      text-decoration: none;
    }
  }
  .Footer__logo {
    font-family: "Lato", sans-serif;
    width: 30%;
    padding-right: $space-m;
    @media only screen and( max-width: $tablet) {
      width: 100%;
      margin-bottom: $space-l;
    }
    line-height: 1;
    letter-spacing: 0.1rem;
    p {
      margin-top: $space-s;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.4;
      letter-spacing: 0;
    }
  }
  .Footer__menu {
    width: 60%;
    @media only screen and( max-width: $tablet) {
      width: 100%;
    }
    font-size: 12px;
    line-height: 1;

    text-decoration: none;
    & > li {
      font-size: 14px;
      margin-top: $space-m;
      &:first-child {
        margin-top: 0;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      font-weight: normal;
    }
    li {
      margin-right: $space-s;
      margin-bottom: $space-s;
    }
  }
  .Footer__copyright {
    font-family: "Lato", sans-serif;
    margin-top: $space-l;
    font-size: 12px;
    width: 100%;
    text-align: center;
    font-weight: normal;
    letter-spacing: 0.05rem;
    border-top: 1px solid #676666;
  }
}
</style>